// @ts-nocheck
import { ofetch } from 'ofetch';
const { gigyaLogout } = useGigyaSession();

export default defineNuxtPlugin(() => {
  globalThis.$fetch = ofetch.create({
    baseURL:
      process.env.NODE_ENV === 'production'
        ? useRuntimeConfig().public.appBaseUrl
        : '',

    // Execute logic before the HTTP request is sent
    onRequest({ request, options }) {
      options.headers?.set(
        useRuntimeConfig().public.customReqHeaders.appVersion.key,
        useRuntimeConfig().public.customReqHeaders.appVersion.value
      );

      addcsrfTokenToRequestObject(options);

      // when no method is specified, then the default method is GET
      if (
        (!options.method || options.method === 'GET') &&
        isTimestampNeeded(request.toString())
      ) {
        options.query = options.query || {};
        options.query.timestamp = new Date().getTime();
      }

      // Standard CORS requests do not send or set any cookies by default.
      // In order to set/send cookie we need to set the .credentials property to include.
      options.credentials = 'include';
    },

    // Handle error related to server response
    onResponseError({ request, options, response }) {
      if (
        response._data.statusCode === 503 ||
        (response._data.statusCode === 403 &&
          response._data.errorCode === 'STALE_REQUEST')
      ) {
        reloadNuxtApp();
      } else if (
        response._data.statusCode === 401 &&
        response._data.errorCode === 'USER_MISMATCH_ERROR'
      ) {
        reloadNuxtApp();
      }
    }
  });
});

// Caching of all files except html is avoided in order to make sure changes are reflected everytime.
const isTimestampNeeded = (url: string): boolean => {
  return (
    url.length > 5 && url.substring(url.length - 5, url.length) !== '.html'
  );
};

//This function adds the CSRF token in the request headers for all backend APIs.
//This is needed to implement protection against CSRF attacks
const addcsrfTokenToRequestObject = (options) => {
  const csrfToken = useCookie('csrf-token');
  options.headers?.set('csrf-token', csrfToken.value);
};
